import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { Edit, Trash, More } from "@rsuite/icons";
import React, { useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import ViewMusicSchedule from "./ViewMusicSchedule";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import MusicScheduleStoresModal from "./MusicScheduleStoresModal";

const MusicScheduleSingleAction = ({
  musicScheduleData,
  onDeleteMusicSchedule,
  onPublishMusicSchedule,
  permission,
  ...props
}: {
  musicScheduleData: any;
  onDeleteMusicSchedule: Function;
  onPublishMusicSchedule: Function;
  permission: any;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const ecryptedMusicScheduleId = encryptUrl(`${musicScheduleData.id}`);

  const musicScheduleUpdateLink = ContentRoutes.UPDATE_MUSIC_SCHEDULE.replace(
    ":id",
    ecryptedMusicScheduleId.toString()
  );
  const navigate = useNavigate();
  const publishText =
    musicScheduleData.status == statusArr.active
      ? t("UNPUBLISH").toLowerCase()
      : t("PUBLISH").toLowerCase();
  const pMessage = t("CONFIRM_ACTION", {
    action:
      musicScheduleData.status == statusArr.active
        ? t("UNPUBLISH").toLowerCase()
        : t("PUBLISH").toLowerCase(),
    entity: t("MUSIC_SCHEDULE").toLowerCase(),
  });

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ) => {
    const handleSelect = (eventKey: any) => {
      if (["view-music-schedule", "view-music-stores"].includes(eventKey)) {
        setOpenModalByName(eventKey);
        dispatch(setActionData(musicScheduleData));
        onClose && onClose();
      } else if (eventKey == "edit-music-schedule") {
        handleEditAction();
      } else if (eventKey == "publish-music-schedule") {
        setOpenPublishModal(true);
        setPublishMessage(pMessage);
      } else if (eventKey == "delete-music-schedule") {
        setOpenDeleteModal(true);
      }
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-music-schedule"}>
            {t("VIEW")}
          </Dropdown.Item>
          <Dropdown.Item eventKey={"view-music-stores"}>
            {t("VIEW")} {t("STORES")}
          </Dropdown.Item>
          {permission.update && (
            <Dropdown.Item eventKey={"edit-music-schedule"}>
              {t("EDIT")}
            </Dropdown.Item>
          )}
          {permission.publish && (
            <Dropdown.Item eventKey={"publish-music-schedule"}>
              {publishText}
            </Dropdown.Item>
          )}
          {permission.delete && (
            <Dropdown.Item eventKey={"delete-music-schedule"}>
              {t("DELETE")}
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Popover>
    );
  };

  function handleEditAction() {
    navigate(`${musicScheduleUpdateLink}`);
  }
  return (
    <div>
      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-music-schedule" && (
        <ViewMusicSchedule
          status={openModalByName === "view-music-schedule" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
      {openModalByName === "view-music-stores" && (
        <MusicScheduleStoresModal
          musicScheduleId={musicScheduleData?.id}
          musicScheduleData={musicScheduleData}
          openModal={openModalByName === "view-music-stores" ? true : false}
          setOpenModal={setOpenModalByName}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteMusicSchedule(musicScheduleData);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("MUSIC_SCHEDULE").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
      <AlertModal
        open={openPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onPublishMusicSchedule(musicScheduleData);
            setOpenPublishModal(false);
          } else {
            setOpenPublishModal(false);
          }
        }}
        displayText={publishMessage}
      />
    </div>
  );
};

export default MusicScheduleSingleAction;
